import Link from 'next/link'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'

export const SignUpFooter: FC = () => {
  const { t } = useTranslation(['signup'])
  return (
    <>
      {t('アカウントをお持ちの場合は')}
      <Link href='/signin'>
        <a>{t('こちら')}</a>
      </Link>
      {t('からログイン')}
    </>
  )
}
